import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-upload-practice-document',
  templateUrl: './dialog-upload-practice-document.component.html',
})
export class DialogUploadPracticeDocumentComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data) {}
}
